<template>
  <div id="setting">
    <ul class="list">
      <li class="item">
        <div class="title">账号信息</div>
        <div class="id">
          <div class="box">
            <div class="key">ID</div>
            <div class="value">{{ userInfo.user.id }}</div>
          </div>
        </div>
        <div class="type">
          <div class="box">
            <div class="key">类型</div>
            <div v-if="isSon !== 'true'" class="value">
              {{ userInfo.user.customerType | identity }}
            </div>
            <div v-if="isSon === 'true'" class="value">
              {{ userInfo.user.subType | subType }}
            </div>
          </div>
          <div class="no">暂不支持修改</div>
        </div>
        <div v-if="isSon === 'true'" class="type">
          <div class="box">
            <div class="key">父账号</div>
            <div class="value">中文知识网</div>
          </div>
        </div>
      </li>
      <li v-if="userInfo.user.customerType === 5" class="item">
        <div class="title">运营者信息</div>
        <div class="type">
          <div class="box">
            <div class="key">运营者姓名</div>
            <div class="value">{{ userInfo.user.id }}</div>
          </div>
          <div class="no">暂不支持修改</div>
        </div>
        <div class="type">
          <div class="box">
            <div class="key">运营者实名信息</div>
            <div class="value">{{ userInfo.user.customerType | identity }}</div>
          </div>
        </div>
      </li>
      <li class="item">
        <div class="title">安全中心</div>
        <div v-if="isSon !== 'true'" class="type">
          <div class="box">
            <div class="key">手机号</div>
            <div class="value">{{ userInfo.user.username }}</div>
          </div>
          <div class="yes" @click="set(0)">更改手机号</div>
        </div>
        <div class="type">
          <div class="box">
            <div class="key">登录密码</div>
            <div class="value">{{ userInfo.user.password }}</div>
          </div>
          <div class="yes" @click="set(1)">修改</div>
        </div>
      </li>
    </ul>
    <Modal
      :scrollable="true"
      v-model="alert"
      width="572px"
      class-name="vertical-center-modal"
      :footer-hide="true"
    >
      <div class="content">
        <Phone @setAlert="setAlert" v-if="type === 0"></Phone>
        <Pwd @setAlert="setAlert" v-if="type === 1"></Pwd>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Phone from "./components/phone";
import Pwd from "./components/pwd";

export default {
  name: "index",
  filters: {
    identity: function (num) {
      if (num === 1) return `普通用户`;
      if (num === 2) return `学者`;
      if (num === 3) return `专家`;
      if (num === 4) return `期刊`;
      if (num === 5) return `机构`;
    },
    subType: function (num) {
      if (num === 1) return `期刊子账号`;
      if (num === 2) return `机构子账号`;
      return "子账号";
    },
  },
  components: { Phone, Pwd },
  computed: {
    ...mapState(["userInfo"]),
  },
  data() {
    return {
      alert: false,
      type: 3,
      isSon: false,
    };
  },
  methods: {
    set(num) {
      this.type = num;
      this.alert = true;
    },
    setAlert() {
      this.type = 3
      this.alert = false;
    },
    async getUserInfo() {
      let data = await this.$apis.loginServe.getUserInfo();
      console.log(data, "data");
      let userObj = {
        token: sessionStorage.getItem("token"),
        hasLogin: true,
        userInfo: data.content,
      };
      // console.log(obj);
      this.$store.commit("loginInfo", userObj);
      console.log('调用11')
    },
  },
  created() {
    this.getUserInfo();
    console.log(this.userInfo.user, "this.userInfo");
    this.isSon = sessionStorage.getItem("isSon");
  },
};
</script>

<style lang="scss" scoped>
#setting {
  .list {
    .item {
      margin-top: 10px;
      width: 1200px;
      padding-bottom: 30px;
      //height: 159px;
      padding-top: 34px;
      background: #ffffff;
      box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.13);
      padding-left: 42px;

      .no {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
      }

      .yes {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #0b35c5;
        cursor: pointer;
      }

      .title {
        width: 120px;
        height: 22px;
        font-size: 22px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 24px;
        margin-bottom: 30px;
      }

      .id {
        //margin-top: 30px;
        .box {
          display: flex;

          .key {
            width: 100px;
            //background: pink;
          }

          .value {
            margin-left: 60px;
          }
        }
      }

      .type {
        width: 95%;
        //background: yellow;
        display: flex;
        justify-content: space-between;
        margin-top: 10px;

        .box {
          display: flex;

          .key {
            width: 100px;
            //background: pink;
          }

          .value {
            margin-left: 60px;
          }
        }
      }
    }
  }
}
</style>
